<template>
    <v-layout align-start justify-start>
        <v-flex>
            <v-toolbar dark>
                <v-btn to="/">HOME</v-btn>
                <v-menu class="hidden-sm-and-up">
                    <v-btn slot="activator"
                            dark
                            icon
                    >
                        <v-icon>more_vert</v-icon>
                    </v-btn>

                    <v-list>
                        <v-list-tile class="white--text" style="background-color: #1E1E1E"  v-if="menu.mobileShow" v-for="(menu, i) in mobileMenu" :key="i"  v-bind:to="{name: menu.link}">
                            <v-list-tile-title>{{ menu.name}}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
                <v-spacer></v-spacer>
                <v-menu class="hidden-xs-only" bottom origin="center center" transition="scale-transition"
                        v-for="(menu, i) in menus" :key="i">

                    <v-btn slot="activator" primary flat v-bind:to="{name: menu.link}">
                        {{ menu.name }}
                    </v-btn>

                    <v-list v-if="menu.submenus">
                        <v-list-tile
                                v-for="(sub, i) in menu.submenus" :key="i"
                                v-bind:to="{name: sub.link}">
                            <v-list-tile-title>{{ sub.name }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
                <v-btn v-if="user" class="blue darken-3" @click.prevent="logout">Logout</v-btn>
            </v-toolbar>
        </v-flex>
    </v-layout>
</template>

<script>
    import firebase from 'firebase'
    export default {
        name: "Navbar",
        computed: {
          mobileMenu(){
              let mobileMenu = []

              for (var i = 0; i < this.menus[0].submenus.length; i++) {
                  if(this.menus[0].submenus[i].mobileShow)
                      mobileMenu.push(this.menus[0].submenus[i])
              }

              for (var i = 0; i < this.menus.length; i++) {
                  if(this.menus[i].mobileShow)
                      mobileMenu.push(this.menus[i])
              }
              return mobileMenu;
          }
        },
        methods: {
            logout() {
                firebase.auth().signOut().then(
                    () => this.$router.push({name: 'Home'})
                )
            }
        },
        created() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    console.log('logged In')
                    this.user = user
                } else {
                    this.user = null
                }
            })
        },
        data: () => ({
            user: null,
            menus: [
                {
                    name: 'PRUDENT',
                    mobileShow: false,
                    submenus: [
                        {
                            name: 'ABOUT US',
                            mobileShow: true,
                            link: 'AboutHome'
                        },
                        {
                            name: 'OUR TEAM',
                            mobileShow: true,
                            link: 'OurTeamHome'
                        }
                        // ,
                        // {
                        //     name: 'DIVERSITY',
                        //     link: 'diversity'
                        // }
                    ]
                },
                {
                    name: 'SERVICES',
                    mobileShow: true,
                    link: 'ServiceHome'
                },
                {
                    name: 'RESOURCES',
                    mobileShow: true,
                    link: 'ResourceHome'
                },
                {
                    name: 'CAREER',
                    mobileShow: true,
                    link: 'CareerHome'
                },
                {
                    name: 'CONTACT',
                    mobileShow: true,
                    link: 'ContactHome'
                }
            ]
        })
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/layout/Navbar.vue